import { css, SerializedStyles } from '@emotion/core';
import {
  rgba,
  buttonNormalize,
  fontBase,
  srOnly,
  media,
  variables,
} from '@domain-group/fe-brary';

export const headerContainer = css`
  display: block;
  height: 54px;
  border-bottom: 1px solid ${variables.colour.neutral200};
  ${media('>=desktop')} {
    height: 70px;
  }
`;
export const header = css`
  display: flex;
  align-items: center;
  background-color: ${variables.colour.white};
  z-index: ${variables.global.layerModal};
  justify-content: space-between;
  height: 54px;
  border-bottom: 1px solid ${variables.colour.neutral200};
  > div {
    display: flex;
    align-items: center;
  }
  ${media('>=desktop')} {
    height: 70px;
    max-width: 1300px;
    margin-left: auto;
    margin-right: auto;
  }
`;

export const headerSrOnly = css`
  ${srOnly};
`;

export const logoContainer = css`
  margin: 0 auto 0 9px;
  position: initial;
  width: auto;
`;

export const logo = css`
  padding-top: 6px;
  svg {
    height: 25px;
    vertical-align: middle;
    ${media('>=desktop')} {
      height: 35px;
    }
  }
`;

export const logoSubHead = css`
  display: none;
  text-transform: uppercase;
  position: relative;
  margin-left: 20px;
  font-size: ${variables.font.h6FontSize};
  font-weight: 700;
  vertical-align: middle;
  ${media('>=tablet')} {
    display: block;
    &::before {
      content: '|';
      position: absolute;
      top: -2px;
      left: -10px;
      color: #e6e9ed;
      font-size: 30px;
      font-weight: 100;
    }
  }
`;

export const mobileOverlay = (isOpen: boolean): SerializedStyles => css`
  opacity: 0;
  visibility: hidden;
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: ${rgba(variables.colour.primary, 0.8)};
  transition: visibility 0s linear 0.25s, opacity 0.25s ease-in-out;
  z-index: ${variables.global.layerPopout};
  ${isOpen &&
  `
      opacity: 1;
      visibility: visible;
      transition: visibility 0s linear 0s, opacity 0.25s ease-in-out;
    `};
`;

export const toggleAndClose = css`
  ${buttonNormalize};
  width: 24px;
  margin: 12px;
  ${media('>=desktop')} {
    display: none;
  }
`;

export const headerNavigation = (isOpen: boolean): SerializedStyles => css`
  position: absolute;
  transform: translateX(-100%);
  top: 0;
  left: 0;
  z-index: ${variables.global.layerModal};
  width: 75%;
  transition: transform 0.3s ease-in-out;
  height: 100vh;
  ${media('>=desktop')} {
    transform: none;
    transition: none;
    display: flex;
    flex: 1 1 0%;
    position: relative;
    z-index: auto;
    height: auto;
    justify-content: space-around;
  }
  @media (min-width: 1064px) {
    justify-content: flex-end;
  }
  ${isOpen &&
  `
    transform: translateX(0);
    box-shadow: 0 19px 38px 0 ${rgba(variables.colour.neutral700, 0.3)},
      0 15px 12px 0  ${rgba(variables.colour.neutral700, 0.22)};
    ${media('>=desktop')} {
      transform: none;
    }
  `}
`;

export const navigationList = css`
  list-style: none;
  margin: 0;
  min-height: 100%;
  background: ${variables.colour.white};
  ${media('>=desktop')} {
    display: flex;
    min-height: 0;
    height: 40px;
  }
  @media (min-width: 1064px) {
    margin-right: 48px;
  }
`;

export const navigationListCallUs = css`
  display: none;
  ${media('>=desktop')} {
    display: inline-block;
  }
`;

export const navigationItemLink = css`
  ${fontBase};
  text-decoration: none;
  padding: 12px 25px 21px 24px;
  color: ${variables.colour.primary};
  display: block;
  ${media('>=desktop')} {
    text-align: center;
    padding: 6px 0;
    margin: 0 24px;
    background: 0;
    text-decoration: none;
    position: relative;
    &:hover,
    &:visited,
    &:active,
    &:focus {
      text-decoration: none;
    }
    &:focus::after,
    &:hover::after {
      width: 100%;
    }
    &::after {
      position: absolute;
      bottom: -2px;
      left: 0;
      right: 0;
      margin: auto;
      width: 0;
      content: '';
      color: transparent;
      background-color: ${variables.colour.secondary};
      height: 2px;
      transition: width 0.15s linear;
    }
  }
  :hover {
    border-left: 3px solid ${variables.colour.secondary};
    ${media('>=desktop')} {
      border-left: 0;
    }
  }
`;

export const ctaButton = css`
  display: flex;
  position: relative;
`;

export const getStartedButton = css`
  margin: 0;
  display: none;
  ${media('>=desktop')} {
    margin: 0 24px 0 13px;
    display: block;
  }
`;

export const loginButton = css`
  display: none;
  ${media('>=desktop')} {
    display: block;
  }
`;

export const loginButtonMobile = css`
  display: block;
  ${media('>=desktop')} {
    display: none;
  }
`;
export const member = css`
  ${fontBase};
  color: ${variables.colour.neutral700};
  display: flex;
  align-items: center;
  cursor: pointer;
  ${media('>=desktop')} {
    color: ${variables.colour.primary};
    display: flex;
    margin-left: 36px;
    margin-right: 12px;
  }
`;

export const memberEmail = css`
  display: none;
  ${media('>=desktop')} {
    display: block;
    margin: 0 12px 0 9px;
  }
`;

export const memberAvatarIcon = css`
  height: 27px;
  margin-left: 15px;
`;

export const memberArrowIcon = css`
  height: 12px;
  display: none;
  ${media('>=desktop')} {
    display: block;
  }
`;

export const memberDropdownList = css`
  background: ${variables.colour.white};
  position: absolute;
  top: 43px;
  right: 2px;
  z-index: ${variables.global.layerPopout};
  border: solid 1px ${variables.colour.neutral100};
  box-shadow: 1px 2px 2px ${rgba(variables.colour.black, 0.07)};
  width: 200px;
  ${media('>=desktop')} {
    width: 320px;
    top: 50px;
  }
`;

export const memberDropdownItem = css`
  height: 65px;
  width: 100%;
  padding-top: 24px;
  padding-left: 24px;
  text-align: left;
  &:nth-last-of-type(2) {
    border-bottom: 1px solid ${variables.colour.neutral200};
  }
  ${media('>=desktop')} {
    height: 65px;
    width: 320px;
  }
`;

export const memberDropdownItemLink = css`
  cursor: pointer;
  text-decoration: none;
  color: ${variables.colour.primary};
  padding: 0;
`;

export const textButton = css`
  border: 0;
  background: none;
  outline: none;
  font: inherit;
  cursor: pointer;
`;
